import { defineStore } from "pinia";
import { decaService } from "@/_services";

export const decaStore = defineStore("deca", {
  state: () => ({
    decas: null,
    decaPreload: null,
    decaGenerated: null,
    error: null,
    customFilterDate: null,
  }),

  actions: {
    setCustomFilterDate(value) {
      this.customFilterDate = value;
    },

    getDecas(pagination, query, sort) {
      this.error = null;
      decaService
        .getDecas(pagination, query, sort)
        .then((result) => {
          this.decas = result;
        })
        .catch((reason) => {
          this.error = reason;
        });
    },

    preloadDeca(stopId) {
      this.error = null;
      this.decaPreload = null;
      return decaService
        .preloadDeca(stopId)
        .then((result) => {
          this.decaPreload = result;
          return result;
        })
        .catch((reason) => {
          this.error = reason;
          throw reason;
        });
    },

    generateDeca(stopId, payload) {
      this.error = null;
      this.decaGenerated = null;
      return decaService
        .generateDeca(stopId, payload)
        .then((result) => {
          this.decaGenerated = result;
          return result;
        })
        .catch((reason) => {
          this.error = reason;
          throw reason;
        });
    },

    printDeca(stopIds) {
      this.error = null;
      return decaService.printDeca(stopIds).catch((reason) => {
        this.error = reason;
        throw reason;
      });
    },
  },
});
